import { createReducer } from 'utils/ReduxUtils';

import { isInterventionWithEvents } from './utils';

const initialState = {};

export default createReducer(initialState, {}, [
  {
    matcher: isInterventionWithEvents,
    reducer: (state, { payload: { id: interventionId, events } }) => ({
      ...state,
      [interventionId]: events.map(({ id }) => id),
    }),
  },
]);
